/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener('DOMContentLoaded', () => {
    const postcoDrawer = document.querySelector('.postco-cart-drawer');

    if (!postcoDrawer) return;

    const observer = new MutationObserver(() => {
      const drawerOpen = postcoDrawer.classList.contains('is-open');

      if (!drawerOpen) {

        // Trigger the theme's native unlock flow
        document.dispatchEvent(
          new CustomEvent('theme:scroll:unlock', {
            bubbles: true,
            detail: 0
          })
        );

        // Safety cleanup
        document.body.style.overflow = '';
        document.body.style.overflowY = '';

        document.documentElement.removeAttribute(
          'data-scroll-locked'
        );
      }
    });

    observer.observe(postcoDrawer, {
      attributes: true,
      attributeFilter: ['class']
    });
  });





  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
